<a routerLink="">
  <fl-logo />
</a>
<fl-top-menu-breadcrumbs [breadcrumbs]="breadcrumbs()" data-qa="top-menu-breadcrumbs" />
@let emissionsOnly = !!permissions()?.includes(permission.EmissionsOnly);
@if (!emissionsOnly) {
  <p-autoComplete
    #autoComplete
    optionValue="idString"
    [placeholder]="'TOP_MENU.GO_TO' | translate"
    [ngModel]="selectedVesselId()"
    [dropdown]="true"
    [suggestions]="filteredVessels()"
    [disabled]="isLoadingVessels()"
    [attr.data-qa]="'top-menu-go-to-vessel'"
    (completeMethod)="filterVesselSuggestions($event)"
    (onSelect)="onVesselSelect($event)"
    (onShow)="onAutoCompleteShow()"
    (onBlur)="resetAutoCompleteValue()"
  >
    <ng-template #item let-item>
      <div [attr.data-qa]="'top-menu-go-to-vessel-' + item.id">{{ item.name }}</div>
    </ng-template>
    <ng-template #dropdownicon>
      @if (isLoadingVessels()) {
        <fl-icon name="pi-spinner" [spin]="true" />
      } @else {
        <fl-icon name="pi-chevron-down" />
      }
    </ng-template>
  </p-autoComplete>
}
<fl-top-menu-clock class="clock" [timezone]="timezone()" />
<div class="buttons">
  <p-button flFullscreenTrigger icon="pi pi-expand" [rounded]="true" [attr.data-qa]="'top-menu-fullscreen'" />
  @if (!licenses().includes(license.Viewer)) {
    <p-multiSelect
      optionValue="id"
      optionLabel="name"
      [autofocusFilter]="true"
      [filterPlaceHolder]="'COMMON.SEARCH' | translate"
      [options]="sortedFleets()"
      [attr.data-qa]="'top-menu-fleet-filter'"
      [(ngModel)]="selectedFleetIds"
      [class.active]="selectedFleetIds().length"
    >
      <ng-template #dropdownicon>
        <fl-icon name="pi-list" size="24px" />
      </ng-template>
      <ng-template #item let-item>
        <div [attr.data-qa]="'top-menu-fleet-filter-' + item.id">{{ item.name }}</div>
      </ng-template>
    </p-multiSelect>
  }
  @if (licenses().includes(license.Notifications) && !emissionsOnly) {
    <p-overlayBadge
      severity="info"
      badgeSize="small"
      [value]="notificationsCount()"
      [badgeDisabled]="!notificationsCount()"
      [attr.data-qa]="'top-menu-notifications'"
      [class.opened]="notificationsMenu.overlayVisible"
      (click)="notificationsMenu.toggle($event)"
    >
      <p-button icon="pi pi-bell" [rounded]="true" />
    </p-overlayBadge>
  }
  <p-popover
    #notificationsMenu
    [dismissable]="!notificationsPinned()"
    (onHide)="notificationsRead.emit()"
    styleClass="top-menu-notifications-popover"
  >
    <!-- Template, not projected content: rows are built only while the popover is open. -->
    <ng-template #content>
      <fl-top-menu-notifications
        [notifications]="notifications()"
        [filteredOutNotificationCount]="filteredOutNotificationCount()"
        [pinned]="notificationsPinned()"
        (pinClick)="notificationsPinned.set(!notificationsPinned())"
      />
    </ng-template>
  </p-popover>
  <p-button
    icon="pi pi-user"
    [rounded]="true"
    [attr.data-qa]="'top-menu-user'"
    (onClick)="userMenu.toggle($event)"
    [class.opened]="userMenu.visible"
  />
  <p-menu #userMenu [popup]="true" [model]="userMenuItems" styleClass="top-menu-user-menu">
    <ng-template #start>
      <div class="user">
        <fl-icon name="pi-user" size="24px" />
        <div>
          <h3>{{ user()?.name }}</h3>
          @if (userRole()) {
            <p>{{ userCustomRoleName() ?? (USER_ROLE_TRANSLATION_KEYS[userRole()!] | translate) }}</p>
          }
          <p>{{ user()?.email }}</p>
        </div>
      </div>

      <div class="user-info">
        @for (item of userInfo(); track item.label) {
          <span class="label">{{ item.label }}:</span>
          <span class="value">{{ item.value }}</span>
        }
      </div>
    </ng-template>
    <ng-template #item let-item>
      @if (item?.routerLink) {
        <a
          [routerLink]="item.routerLink"
          [attr.data-automationid]="item.automationId"
          [attr.tabindex]="-1"
          [attr.data-pc-section]="'action'"
          [attr.title]="item.title"
          routerLinkActive="p-menu-item-link-active"
          class="p-menu-item-link"
          pRipple
        >
          @if (item.icon) {
            <fl-icon [name]="item.icon" [outlined]="true" size="24px" />
          }
          <span class="p-menu-item-label">{{ item.label }}</span>
        </a>
      } @else {
        <a
          [attr.href]="null"
          [attr.data-automationid]="item.automationId"
          [attr.tabindex]="-1"
          [attr.data-pc-section]="'action'"
          class="p-menu-item-link"
          pRipple
        >
          @if (item.icon) {
            <fl-icon [name]="item.icon" [outlined]="true" size="24px" />
          }
          <span class="p-menu-item-label">{{ item.label }}</span>
        </a>
      }
    </ng-template>
  </p-menu>
</div>
